import React, { Fragment } from 'react'

function Tag({ tags = [] }) {
    return (
        <Fragment>
            {tags.map((tag, index) => {
                return (
                    <Fragment key={tag}>
                        <span>#{tag}</span>
                        {index !== tags.length - 1 && <span>, </span>}
                    </Fragment>
                )
            })}
        </Fragment>
    )
}

export default Tag
